<template>
  <div>
    <v-btn icon color="green" v-on:click="addData()">
      <v-icon>add</v-icon>
    </v-btn>
    Shooting Word
    <v-stepper v-model="currentStep">
      <v-stepper-header>
        <template v-for="n in steps">
          <v-stepper-step
            :key="`${n}-step`"
            :complete="currentStep > n"
            :step="n"
            editable
          >
            <!-- item {{ n }} -->
          </v-stepper-step>

          <v-divider v-if="n !== steps" :key="n"></v-divider>
        </template>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content v-for="n in steps" :key="`${n}-content`" :step="n">
          <v-form ref="formRound">
            <v-card v-if="currentStep > 0">
              <v-toolbar dark>
                <v-toolbar-title
                  >Shooting Word {{ currentStep }}</v-toolbar-title
                >
                <v-btn
                  v-if="steps > 1"
                  color="error"
                  small
                  absolute
                  fab
                  right
                  @click="onClickRemoveByIndex(currentStep - 1)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-toolbar>
              <v-container v-if="data[currentStep - 1]">
                <v-layout column class="elevation-5" style="padding: 20px">
                  <b style="align-self: center;">Shooting Word</b>
                  <v-flex>
                    <v-text-field
                      label="Word"
                      :value="data[currentStep - 1].word"
                      v-model="data[currentStep - 1].word"
                      :rules="[rules.required]"
                      @change="e => onChangeRound('word', e)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <img
                      v-if="data[currentStep - 1].image_uri"
                      :src="data[currentStep - 1].image_uri"
                      :alt="data[currentStep - 1].image_uri"
                      class="content_img"
                    />
                    <v-text-field
                      label="Image URI (URL or Select file)"
                      :value="data[currentStep - 1].image_uri"
                      v-model="data[currentStep - 1].image_uri"
                      :rules="[rules.validURI]"
                      @change="e => onChangeRound('image_uri', e)"
                    ></v-text-field>
                    <v-btn dark @click="setResource('image', 'isImageUri')"
                      ><v-icon>image</v-icon>Select Image</v-btn
                    >
                  </v-flex>
                  <v-flex>
                    <SpriteSheet
                      :title="'Use Sprite Sheet'"
                      :isToggle="data[currentStep - 1].is_sprite_sheet"
                      :fieldname="'Edit Move Sheet Data'"
                      :object="data[currentStep - 1].sprite_sheet_data"
                      :color="'dark'"
                      @onchangeToggleSprite="
                        onchangeToggleSprite($event, currentStep - 1)
                      "
                      @saveSpriteSheetData="
                        saveSpriteSheetData($event, currentStep - 1)
                      "
                    />
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      label="Sound URI (URL or Select file)"
                      :value="data[currentStep - 1].sound_uri"
                      v-model="data[currentStep - 1].sound_uri"
                      :rules="[rules.validURI]"
                      @change="e => onChangeRound('sound_uri', e)"
                    ></v-text-field>
                    <v-btn dark @click="setResource('sound', 'isSoundUri')"
                      ><v-icon>audiotrack</v-icon>Select Sound</v-btn
                    >
                  </v-flex>
                </v-layout>
                <v-layout column class="elevation-5" style="padding: 20px">
                  <b style="align-self: center;">Point</b>
                  <v-flex>
                    <v-text-field
                      label="Collect Count"
                      type="number"
                      v-model.number="data[currentStep - 1].collect_count"
                      @change="e => onChangeRound('collect_count', e)"
                    ></v-text-field>
                    <v-text-field
                      label="Hit Point"
                      type="number"
                      v-model.number="data[currentStep - 1].hit_point"
                      @change="e => onChangeRound('hit_point', e)"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="currentStep > 1"
                color="red"
                dark
                @click="onClickBackStep()"
                >Previous</v-btn
              >
              <v-btn
                v-if="currentStep < steps"
                color="primary"
                dark
                @click="onClickNextStep()"
                >Next</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <ResourceSelect
      v-if="isEditResource"
      :resourceType="resourceType"
      :isShow="isEditResource"
      :close="closeEditResource"
      :save="saveEditResource"
      :value="uriResource"
      :onSelect="onSelectResource"
    />
  </div>
</template>

<script>
import swal from 'sweetalert2';
import { mapActions, mapState } from 'vuex';
import ResourceSelect from '../../../../components/ResourceSelect.vue';
import rules from '../../../../utils/ruleValidate';
import constants from '../../../../constants';
import SpriteSheet from '../../../../components/SpriteSheetNew.vue';
import { keyExists } from '../../../../utils/lib/keyExists.js';

export default {
  name: 'GameRound',
  components: { ResourceSelect, SpriteSheet },
  computed: {
    ...mapState({
      shootingArrowStore: state => state.shooting_arrow,
      shooting_word: state =>
        state.shooting_arrow.selectedShootingArrow.shooting_word,
      updatedShootingArrow: state => state.shooting_arrow.updateShootingArrow,
    }),
    isEditResource() {
      if (this.resourceType) return this.resource[this.resourceType].isEdit;
      else return false;
    },
    uriResource() {
      if (this.resourceType) return this.resource[this.resourceType].selectUri;
      else return false;
    },
    currentGameRoundStep() {
      return this.currentStep;
    },
  },
  data() {
    return {
      keyExists,
      constants,
      rules,
      currentStep: 1,
      steps: 1,
      data: [],
      valid: true,
      resource: {
        image: {
          isEdit: false,
          selectUri: '',
        },
        sound: {
          isEdit: false,
          selectUri: '',
        },
      },
      resourceType: '',
    };
  },
  props: {
    isCreate: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions('shooting_arrow', ['setStateByKey']),
    limitData() {
      return 5;
    },
    checkSpriteSheetData(array_of_object) {
      let assigned_sprite_sheet_data = [];
      array_of_object.forEach(element => {
        assigned_sprite_sheet_data.push(this.spriteSheetCalculator(element));
      });
      return assigned_sprite_sheet_data;
    },
    spriteSheetCalculator(object) {
      const default_shooting_arrow_sprite_sheet_data = {
        column: 1,
        row: 1,
        frame_ms: 0,
        loop_count: -1,
      };
      let altered_object = Object.assign({}, object);
      const expected_default = {
        is_sprite_sheet: false,
        sprite_sheet_data: JSON.parse(
          JSON.stringify(default_shooting_arrow_sprite_sheet_data),
        ),
      };
      if (
        !this.keyExists(object, 'is_sprite_sheet') ||
        object.is_sprite_sheet == false
      ) {
        altered_object.is_sprite_sheet = expected_default.is_sprite_sheet;
        this.onChangeRound('is_sprite_sheet', expected_default.is_sprite_sheet);
      }
      if (
        !this.keyExists(object, 'sprite_sheet_data') ||
        object.sprite_sheet_data === null
      ) {
        this.onChangeRound(
          'sprite_sheet_data',
          expected_default.sprite_sheet_data,
        );
        altered_object.sprite_sheet_data = expected_default.sprite_sheet_data;
      }
      return altered_object;
    },
    onchangeToggleSprite({ value }, index) {
      this.data[index].is_sprite_sheet = value;
      this.onChangeRound('is_sprite_sheet', value);
    },
    saveSpriteSheetData({ value }, index) {
      this.data[index].sprite_sheet_data = value;
      this.onChangeRound('sprite_sheet_data', value);
    },
    setSpriteSheetData() {
      this.data = [...this.checkSpriteSheetData(this.data)];
    },
    addData() {
      const defaultData = JSON.parse(
        JSON.stringify(this.shootingArrowStore.defaultCreate.shooting_word[0]),
      );
      if (this.data.length < this.limitData()) {
        this.data.push(defaultData);
        this.onChangeRound();
        this.currentStep = this.data.length;
        this.steps = this.data.length;
      }
    },
    onClickRemoveByIndex(index) {
      swal
        .fire({
          titleText: `Are your sure to remove item ${index + 1}?`,
          confirmButtonColor: 'red',
          confirmButtonText: 'Remove',
          showCancelButton: true,
          type: 'warning',
        })
        .then(result => {
          if (result.value) {
            this.data.splice(index, 1);
            this.onChangeRound();
            this.steps = this.data.length;
            if (this.currentStep === 1) {
              this.currentStep = 1;
            } else this.currentStep -= 1;
          }
        });
    },
    onClickNextStep() {
      if (this.currentStep < this.steps) {
        this.currentStep += 1;
      }
    },
    onClickBackStep() {
      if (this.currentStep > 0) {
        this.currentStep -= 1;
      }
    },
    onChangeRound() {
      this.$emit('validate', this.valid);
      if (this.$refs.formRound[0].validate()) {
        this.isCreate
          ? this.setStateByKey({
              statekey: 'createShootingArrow',
              key: 'shooting_word',
              value: this.data,
            })
          : this.setStateByKey({
              statekey: 'updateShootingArrow',
              key: 'shooting_word',
              value: this.data,
            });
      }
    },
    setResource(resource, isType) {
      //resource = image||sound||video
      //isType = isCorrectImage
      if (isType) this.resource[resource][isType] = true;
      this.resourceType = resource;
      this.resource[resource].isEdit = true;
    },
    onSelectResource(uri) {
      const resourceType = this.resourceType;
      this.resource[resourceType].selectUri = uri;
    },
    saveEditResource() {
      const resourceType = this.resourceType;
      const uri = this.resource[resourceType].selectUri;
      const index = this.currentStep - 1;
      switch (resourceType) {
        case 'image':
          if (this.resource[resourceType].isImageUri) {
            this.data[index].image_uri = uri;
            this.resource[resourceType].isImageUri = false;
          } else if (this.resource[resourceType].isImageBoxUri) {
            this.data[index].image_box_uri = uri;
            this.resource[resourceType].isImageBoxUri = false;
          }
          break;
        case 'sound':
          if (this.resource[resourceType].isSoundUri) {
            this.data[index].sound_uri = uri;
            this.resource[resourceType].isSoundUri = false;
          }
          break;
        default:
          break;
      }
      this.onChangeRound();
      this.closeEditResource();
    },
    closeEditResource() {
      this.resource[this.resourceType].isEdit = false;
      this.resource[this.resourceType].selectUri = '';
      this.resourceType = '';
    },
  },
  mounted() {
    if (this.isCreate) {
      this.data = JSON.parse(
        JSON.stringify(this.shootingArrowStore.defaultCreate.shooting_word),
      );
    } else {
      this.data = JSON.parse(JSON.stringify(this.shooting_word));
      this.setSpriteSheetData();
      this.steps = this.data.length;
    }
  },
};
</script>
